import artistImg from '../images/artist.jpg';
import workcuaartist from '../images/hinh1.jpg'
import workcuaartist1 from '../images/hinh2.jpg'
import workcuaartist2 from '../images/hinh3.jpg'
import workcuaartist3 from '../images/hinh4.jpg'
import workcuaartist4 from '../images/hinh5.jpg'
import workcuaartist5 from '../images/hinh6.jpg'
import workcuaartist6 from '../images/hinh7.jpg'
import workcuaartist7 from '../images/hinh8.jpg'
import workcuaartist8 from '../images/hinh9.jpg'
import workcuaartist9 from '../images/hinh10.jpg'
import { useLanguage } from './LanguageContext';

function Artist() {
    const {language} = useLanguage()
  return (
    <>
    {language === "en" ? ( <div className='bg-lightBrown px-6 min-h-screen overflow-hidden'>
      <div id="container1" className="flex flex-col md:flex-row-reverse sm:space-x-8 space-y-6 sm:space-y-0 p-3 justify-center">
    <div data-aos="fade-left" id="artist" className="sm:w-1/2  flex justify-center items-center">
      <img 
        alt="artist profile img" 
        src={artistImg} 
        className="object-cover rounded-lg  md:h-[680px]" 
      />
    </div>
    <div data-aos="fade-right" id="info" className="flex flex-col text-start sm:w-2/3 w-full space-y-2 text-black pt-6 sm:pt-20 md:pt-52">
      <h1 className="text-[40px] didot">Datson</h1>
      <p className="text-md md:text-lg pt-4 avenir">
      Surpassing all frameworks and limitations, Datson's artistic tattoo works always showcase a refined, elegant beauty, full of artistic expression.</p>
      <p className="text-md md:text-lg pt-4 avenir">
      Personalization and aesthetics are always prioritized by Datson in every piece of work, with meticulous attention to detail honed through years of experience, creating tattoos that captivate and inspire lasting beauty over time.
      </p>

      <div>
  

</div>
    </div>
  </div>

      <div data-aos="fade-up" id='container2'>
        <section className="py-6">
          <div className="container flex flex-col justify-center p-4 mx-auto">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist1} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist2} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist3} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist4} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist5} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist6} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist7} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist8} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist9} alt='tattooImg'/>
            </div>
          </div>
        </section>
      </div>
    </div>) : ( <div className='bg-lightBrown px-6 min-h-screen overflow-hidden'>
      <div id="container1" className="flex flex-col md:flex-row-reverse sm:space-x-8 space-y-6 sm:space-y-0 p-3 justify-center">
    <div data-aos="fade-left" id="artist" className="sm:w-1/2  flex justify-center items-center">
      <img 
        alt="artist profile img" 
        src={artistImg} 
        className="object-cover rounded-lg  md:h-[680px]" 
      />
    </div>
    <div data-aos="fade-right" id="info" className="flex flex-col text-start sm:w-2/3 w-full space-y-2 text-black pt-6 sm:pt-20 md:pt-52">
      <h1 className="text-[40px] didot">Datson</h1>
      <p className="text-md md:text-lg pt-4 avenir">
        Vượt qua mọi khuôn khổ và giới hạn, các tác phẩm hình xăm nghệ thuật của Datson luôn thể hiện vẻ đẹp tinh tế, sang trọng và mang đầy tính nghệ thuật.
      </p>
      <p className="text-md md:text-lg pt-4 avenir">
        Yếu tố cá nhân hoá và tính thẩm mỹ luôn được Datson đề cao trong mọi tác phẩm, sự tỉ mỉ và trau chuốt được thể hiện thông qua nhiều năm kinh nghiệm, tạo ra những hình xăm thu hút truyền cảm hứng vẻ đẹp bền bỉ theo thời gian.
      </p>

      <div>
  

</div>
    </div>
  </div>

      <div data-aos="fade-up" id='container2'>
        <section className="py-6">
          <div  className="container flex flex-col justify-center p-4 mx-auto">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist1} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist2} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist3} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist4} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist5} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist6} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist7} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist8} alt='tattooImg'/>
              <img className="object-cover w-full rounded-md dark:bg-gray-500 aspect-square" src={workcuaartist9} alt='tattooImg'/>
            </div>
          </div>
        </section>
      </div>
    </div>)}
    
    </>
  );
}

export default Artist;
